<div class="loader-holder" *ngIf='isActive'>
    <div class="spinner-border loader" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>